<template>
  <div>
    <div style="margin-top: 20px; font-size: 26px; font-weight: bold">二段物流更新</div>
    <div style="margin-top: 20px">
      <el-input
        v-model="trackingNo"
        placeholder="同步物流单号"
        style="width: 300px"
        class="filter-item"
        clearable
      />
      <!-- <el-input
        v-model="shipperCode"
        placeholder="二段物流公司名称"
        style="width: 300px"
        class="filter-item"
        clearable
      /> -->
      <el-select
        v-model="shipperCode"
        class="filter-item"
        filterable
        placeholder="二段物流公司名称"
        clearable
      >
        <el-option
          v-for="(item, index) in kuaidiList"
          :key="index"
          :label="item"
          :value="item"
          >{{ item }}</el-option
        >
      </el-select>
      <el-input
        v-model="expressNo"
        placeholder="二段物流单号"
        style="width: 300px"
        class="filter-item"
        clearable
      />
      <el-button v-waves class="filter-item" type="primary" @click="commit">
        提交
      </el-button>
      <br /><br />
      结果：<span>{{ commitResult }}</span>
      <span style="color: red">{{ errorCommitResult }}</span>
    </div>
    <div>
      <div style="margin-top: 20px; font-size: 26px; font-weight: bold">订单信息查询</div>
      <el-input
        v-model="trackingNoSel"
        placeholder="同步物流单号"
        style="width: 300px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="customerName"
        placeholder="手机号后四位"
        style="width: 300px"
        class="filter-item"
        clearable
      />
      <!-- <el-button v-waves class="filter-item" type="primary" @click="queryByTrackingNo">
        查询
      </el-button> -->
      <el-button v-waves class="filter-item" type="primary" @click="selectOrderTrack">
        查询
      </el-button>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <span style="color: red">{{ queryErrorMessage }}</span>
      <br /><br />
      <b>详细信息</b>：
      <!-- 【同步物流单号】：<span>{{ queryResult.tracking_no }}</span>; 【用户id】：<span>{{ queryResult.user_id }}</span>;<b>【订单编号】：</b><span>{{ queryResult.tid }}</span>;  -->

      <b>【一段物流单号】：</b><span>{{ queryResult.express_no }}</span
      >； <b>【一段物流公司】：</b><span>{{ queryResult.shipper_code }}</span
      >； <b>【二段物流单号】：</b><span>{{ queryResult.two_express_no }}</span
      >； <b>【二段物流公司】：</b><span>{{ queryResult.two_shipper_code }}</span
      >；<b>【发件人电话】：</b><span>{{ queryResult.send_tel }}</span
      >； <br />
      <b>【收件人电话】：</b><span>{{ queryResult.recipient_tel }}</span
      >； <b>【取件码】：</b><span>{{ queryResult.pick_code }}</span
      >； <b>【代收点】：</b><span>{{ queryResult.address }}</span
      >； <b>【收件人详细地址】：</b><span>{{ queryResult.expressAddress }}</span
      >；<br /><br />
      <div style="text-align: left; margin-left: 10%; font-size: 22px">
        <b>物流轨迹</b>：
      </div>
      <el-table
        key="0"
        :data="list"
        border
        fit
        highlight-current-row
        style="width: 80%; margin-left: 10%"
        :row-style="{ height: '0' }"
        :cell-style="{ padding: '6px 0' }"
      >
        <el-table-column label="AcceptStation" width="800px" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.AcceptStation }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Action" width="110px" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.Action }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Location" width="140px" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.Location }}</span>
          </template>
        </el-table-column>
        <el-table-column label="AcceptTime" width="200px" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.AcceptTime }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import waves from "@/directive/waves"; // waves directive

export default {
  name: "secondGenerationLogistics",
  directives: { waves },
  data() {
    return {
      trackingNo: "",
      shipperCode: "",
      expressNo: "",
      commitResult: "",
      errorCommitResult: "",
      kuaidiList: [
        "申通快递",
        "圆通速递",
        "韵达速递",
        "邮政快递包裹",
        "EMS",
        "顺丰速运",
        "京东快递",
        "优速快递",
        "德邦快递",
        "极兔速递",
        "菜鸟速递",
        "菜鸟橙运",
        "丹鸟物流",
        "宅急送",
        "丰网速运",
        "中通快递",
        "韵达快递",
        "圆通快递",
        "京东配送",
        "邮政EMS",
        "邮政电商标快",
        "安能快递",
        "安能快运/物流",
        "安捷快递",
        "安迅物流",
        "安邮美国",
        "亚马逊物流",
        "澳门邮政",
        "澳多多",
        "澳邮专线",
        "安鲜达",
        "安敏物流",
        "安得物流",
        "澳德物流",
        "转运四方",
        "A2U速递",
        "AAE全球专递",
        "明大快递",
        "德国雄鹰速递",
        "安达信",
        "全程快递",
        "德方物流",
        "卡邦配送",
        "加拿大民航快递",
        "捷记方舟",
        "AlfaTrex",
        "无忧物流",
        "ALLIED",
        "心怡物流",
        "亚马逊中国订单",
        "amazon-国际订单",
        "安家同城快运",
        "青岛安捷快递",
        "Anteraja",
        "荷属安的列斯荷兰邮政",
        "安信达",
        "澳速物流",
        "Aramex",
        "ARC",
        "澳达国际物流",
        "澳货通",
        "奥地利邮政",
        "AUV国际快递",
        "澳新物流",
        "安鹿物流",
        "八达通",
        "百腾物流",
        "奔腾物流",
        "八方安运",
        "百世国际",
        "百世云配",
        "宝通快递",
        "8+1物流",
        "报通快递",
        "BDC快递",
        "北京丰越供应链",
        "飛斯特",
        "败欧洲",
        "百福东方物流",
        "上海缤纷物流",
        "彪记快递",
        "青云物流",
        "鑫锐达",
        "远通盛源",
        "佰乐捷通",
        "比利时邮政",
        "蓝天国际航空快递",
        "巴伦支快递",
        "标杆物流",
        "笨鸟国际",
        "堡昕德速递",
        "速方(Sufast)",
        "百千诚物流",
        "宏桥国际物流",
        "百事亨通速递",
        "邦泰快运",
        "展勤快递",
        "百世快运",
        "帮帮发转运",
        "百城通物流",
        "百米快运",
        "北京渡石",
        "重庆博卡联物流",
        "春风物流",
        "菜鸟橙运",
        "广东诚通物流",
        "传喜物流",
        "窝里快购",
        "城市100",
        "CEVA物流",
        "城际快递",
        "长通物流",
        "CNPEX中邮快递",
        "COE东方快递",
        "长沙创一",
        "成都善途速运",
        "加拿大邮政",
        "能装能送",
        "卢森堡航空",
        "广州信邦",
        "钏博物流",
        "中集冷云",
        "中迅三方",
        "捷祥物流",
        "鑫宸物流",
        "银雁专送",
        "河北橙配",
        "城通物流",
        "荣通国际",
        "SQK国际速递",
        "嘉荣物流",
        "CHS中环国际快递",
        "诚和通",
        "中国香港骏辉物流",
        "城市映急",
        "大韩通运",
        "城晓国际快递",
        "出口易",
        "澳通华人物流",
        "群航国际物流",
        "CNAIR",
        "中澳速递",
        "马珂博逻",
        "速舟物流",
        "中国翼",
        "华中快递",
        "重庆星程快递",
        "环旅快运",
        "新时速物流",
        "村通快递",
        "小飞侠速递",
        "云南诚中物流",
        "联合运通",
        "CBO钏博物流",
        "佳吉快运",
        "畅顺通达",
        "D速物流",
        "到了港",
        "大田物流",
        "大众佐川急便",
        "叮当同城",
        "多道物流",
        "深圳德创物流",
        "德豪驿",
        "德坤物流",
        "澳行快递",
        "东风全球速递",
        "达发物流",
        "递五方云仓",
        "云南滇驿物流",
        "递达速运",
        "叮咚澳洲转运",
        "叮咚快递",
        "递四方澳洲",
        "递四方美国",
        "吉布提",
        "东瀚物流",
        "DPD",
        "老司机国际快递",
        "德淘邦",
        "德邦快运/德邦物流",
        "大马鹿",
        "东方汇",
        "递易家",
        "E特快",
        "东方航空物流",
        "邮速达",
        "东西E全运",
        "易联通达",
        "澳州顺风快递",
        "EMS包裹",
        "EMS物流",
        "贰仟家物流",
        "europeanecom",
        "可可树美中速运",
        "7号速递",
        "易转运",
        "EMS国内",
        "EWE",
        "E通速递",
        "飞康达",
        "凡宇货的",
        "速派快递",
        "丰程物流",
        "FEDEX联邦（国内）",
        "飞快达",
        "凤凰快递",
        "奉天物流",
        "四方格",
        "全速快递",
        "富吉速运",
        "法翔速运",
        "飞豹快递",
        "泛球物流",
        "丰巢",
        "飞狐快递",
        "复融供应链",
        "飞远配送",
        "凡宇速递",
        "丰通快运",
        "冠达",
        "广东邮政",
        "共速达",
        "快捷快物流",
        "全网物流",
        "容智快运",
        "国际邮政包裹",
        "时安达速递",
        "万通快递",
        "冠泰",
        "GTS快递（广通速递）",
        "广东通路",
        "永邦快递",
        "全联速运",
        "天天快物流",
        "广州安能聚创物流",
        "贵州星程快递",
        "广通",
        "冠达快递",
        "广通速递",
        "高铁快运",
        "迦递快递",
        "港快速递",
        "高铁速递",
        "广东易代收",
        "黑狗冷链",
        "弘家物流",
        "恒路物流",
        "天地华宇",
        "鸿桥供应链",
        "海派通物流公司",
        "华强物流",
        "华夏龙物流",
        "河北建华",
        "汇达快递",
        "汇丰物流",
        "华航快递",
        "华翰物流",
        "海盟速递",
        "华企快运",
        "华兴物流",
        "昊盛物流",
        "鸿泰物流",
        "合肥汇文",
        "辉隆物流",
        "宏利德物流",
        "海红网送",
        "航宇快递",
        "豪翔物流",
        "开心快递",
        "宏递快运",
        "黑猫速运",
        "合心速递",
        "环国运物流",
        "华瀚快递",
        "海欣斯快递",
        "Hi淘易快递",
        "猴急送物流",
        "飞豹速递",
        "香港邮政",
        "互联快运",
        "共联配",
        "海联快递",
        "顺时达物流",
        "中强物流",
        "如家国际快递",
        "居家通",
        "洪都拉斯",
        "宏捷国际物流",
        "宏品物流",
        "海硕高铁速递",
        "户尚冷链物流",
        "恒通快递",
        "环东物流",
        "华夏货运",
        "汇峰物流",
        "汇霖大货网",
        "货拉拉物流",
        "户通物流",
        "鸿远物流",
        "上海昊宏国际货物",
        "恒宇运通",
        "华企快递",
        "韩润物流",
        "货运皇物流",
        "好来运快递",
        "皇家物流",
        "海信物流",
        "汇森速运",
        "徽托邦物流",
        "爱拜物流",
        "泛太优达",
        "无限速递",
        "捷安达",
        "京广速递",
        "九曳供应链",
        "急先达",
        "晋越快递",
        "佳成国际",
        "嘉诚速达",
        "急递",
        "捷仕",
        "佳辰国际速递",
        "佳家通货运",
        "加佳物流",
        "佳吉快递",
        "嘉贤物流",
        "捷邦物流",
        "极光转运",
        "金岸物流",
        "锦程物流",
        "近端",
        "景顺物流",
        "劲通快递",
        "冀速物流",
        "久久物流",
        "佳捷翔物流",
        "极速达",
        "绝配国际速递",
        "金润荷役物流",
        "骏绅物流",
        "时达通",
        "聚鼎物流",
        "聚盟共建",
        "骏丰国际速递",
        "聚物物流",
        "捷特快递",
        "精英速运",
        "加运美",
        "景光物流",
        "佳怡物流",
        "京东快运",
        "金大物流",
        "跨越速运",
        "快服务",
        "快速递物流",
        "康力物流",
        "快淘快递",
        "考拉国际速递",
        "科捷物流",
        "嘉里大荣物流",
        "启邦国际物流",
        "科紫物流",
        "快航飞递",
        "考拉速递",
        "韩国邮政韩文",
        "淘韩国际快递",
        "四川快优达速递",
        "凯信达",
        "快优达速递",
        "快8速运",
        "龙邦快递",
        "蓝弧快递",
        "拉火速运",
        "蓝镖快递",
        "立白宝凯物流",
        "两点之间",
        "楽道物流",
        "乐递供应链",
        "云豹国际货运",
        "美联快递",
        "联合速递",
        "联合快递",
        "联邦快递-英文",
        "成都立即送",
        "领送送",
        "小熊物流",
        "新易泰",
        "龙邦速递",
        "加拿大龙行速运",
        "长风物流",
        "6LSEXPRESS",
        "乐天速递",
        "联通快递",
        "陆本速递",
        "论道国际物流",
        "绿卡城配",
        "联运通物流",
        "乐捷递",
        "立即送",
        "联昊通速递",
        "民邦快递",
        "民航快递",
        "美快",
        "门对门快递",
        "今枫国际快运",
        "迈达物流",
        "美泰物流",
        "美西快递",
        "魔速达",
        "闽盛快递",
        "密尔克卫",
        "迈隆递运",
        "明亮物流",
        "美乐维冷链物流",
        "南方传媒物流",
        "星云速递",
        "尼尔物流",
        "速尔哪吒",
        "云链航空",
        "南天物流",
        "腾达速递",
        "诺尔国际物流",
        "偌亚奥国际快递",
        "新西兰中通",
        "能达速递",
        "ONTRAC",
        "平安达腾飞快递",
        "泛捷快递",
        "品骏快递",
        "陪行物流",
        "诚一物流",
        "英国邮政大包EMS",
        "急顺通",
        "普畅物流",
        "全球速递",
        "派尔快递",
        "配思货运",
        "鹏程快递",
        "品信快递",
        "龙行天下",
        "PostElbe",
        "荷兰邮政-中国件",
        "PCAExpress",
        "皮牙子快递",
        "全晨快递",
        "全日通快递",
        "快客快递",
        "全信通",
        "秦邦快运",
        "雪域快递",
        "雪域易购",
        "全川摩运",
        "千里速递",
        "秦岭智能速运",
        "全球邮政",
        "全际通",
        "全速通",
        "全通快运",
        "七曜中邮",
        "如风达",
        "荣庆物流",
        "日日顺物流",
        "日昱物流",
        "人人转运",
        "睿和泰速运",
        "锐界同城",
        "日日顺快线",
        "日日顺智慧物联",
        "瑞丰速递",
        "赛澳递",
        "苏宁物流",
        "圣安物流",
        "上大物流",
        "盛丰物流",
        "速通物流",
        "速腾快递",
        "速必达物流",
        "速递e站",
        "速呈宅配",
        "速尔快递",
        "山东海红",
        "盛辉物流",
        "穗佳物流",
        "三态速递",
        "山西红马甲",
        "世运快递",
        "盛通快递",
        "郑州速捷",
        "赛澳递for买卖宝",
        "叁虎物流",
        "中加国际快递",
        "四川星程快递",
        "药淘齐物流",
        "速达速递",
        "尚橙物流",
        "上海快通",
        "山西建华",
        "捎客物流",
        "杰响物流",
        "闪货极速达",
        "上海林道货运",
        "同城快寄",
        "顺丰-繁体",
        "顺丰快运",
        "顺丰冷链",
        "顺捷达",
        "顺捷丰达",
        "顺士达速运",
        "签收快递",
        "中外运空运",
        "中外运速递-中文",
        "易普递",
        "四季安物流",
        "行必达",
        "申必达",
        "速速达",
        "星速递",
        "星运快递",
        "美国申通",
        "申通新西兰",
        "智德物流",
        "速豹",
        "特急便物流",
        "速风快递",
        "速品快递",
        "苏里南",
        "瑞士邮政",
        "瑞典邮政",
        "三象速递",
        "红马甲物流",
        "沈阳佳惠尔",
        "深圳DPEX",
        "世华通物流",
        "深圳邮政",
        "顺心捷达",
        "商桥物流",
        "佳旺达物流",
        "台湾邮政",
        "泰联物流",
        "唐山申通",
        "特急送",
        "通和天下",
        "通用物流",
        "泰进物流",
        "特宝专送",
        "天翔快递",
        "万家通快递",
        "泰实货运",
        "老扬州物流",
        "明通国际快递",
        "通达兴物流",
        "运联科技",
        "铁中快运",
        "华宇物流",
        "天玺物流",
        "泰捷达物流",
        "优联吉运",
        "UTAO优到",
        "全一快递",
        "万家康",
        "万家物流",
        "中粮我买网",
        "万象物流",
        "微特派",
        "宁夏万家通",
        "万达美",
        "威盛快递",
        "凡仕特物流",
        "沃埃家",
        "伍圆速递",
        "51跨境通",
        "温通物流",
        "武汉晓毕物流",
        "迅驰物流",
        "信丰物流",
        "希优特",
        "祥龙运通",
        "新杰物流",
        "鑫梦成",
        "新宁物流",
        "鑫通宝物流",
        "国晶物流",
        "祥龙运通物流",
        "翔腾物流",
        "喜来快递",
        "迅选物流",
        "行云物流",
        "鑫远东速运",
        "西邮寄",
        "晓毕物流",
        "永昌物流",
        "宇达物流",
        "源安达快递",
        "远成物流",
        "远成快运",
        "义达国际物流",
        "药康达快递",
        "原飞航物流",
        "耀奇物流",
        "亿领速运",
        "亿顺航",
        "易通达",
        "鼹鼠快送",
        "运通快运",
        "亚风快递",
        "运通快递",
        "亿翔快递",
        "运东西网",
        "壹米滴答",
        "一站通速运",
        "驭丰速运",
        "余氏东风",
        "耀飞快递",
        "韵达快运",
        "云路",
        "邮必佳",
        "越丰物流",
        "顺捷丰达/银捷速递",
        "英脉物流",
        "音素快运",
        "一统飞鸿",
        "亚马逊中国",
        "一辉物流",
        "易达丰国际速递",
        "易航物流",
        "英超物流",
        "一起送",
        "一正达速运",
        "武汉优进汇",
        "洋口岸",
        "黑猫同城送",
        "永邦国际物流",
        "永昌物流",
        "邮必佳快递",
        "邮畅快运",
        "邮来速递",
        "壹品速递",
        "远盾物流",
        "圆通快运",
        "元智捷诚",
        "宇捷通",
        "美国云达",
        "韵丰物流",
        "运通速运",
        "邮驿帮速运",
        "西安运逸快递",
        "远洋国际快递",
        "鹰运",
        "圆通国际",
        "宇鑫物流",
        "包裹/平邮/挂号信",
        "一智通",
        "一路发物流",
        "云聚物流",
        "宇佳物流",
        "众邮快递",
        "中铁快运",
        "中天万运",
        "中外运速递",
        "澳转运",
        "八达网",
        "贝易购",
        "赤兔马转运",
        "浩运物流",
        "逐电快运",
        "卓实快运",
        "CUL中美速递",
        "ETD",
        "风驰快递",
        "风雷速递",
        "皓晨优递",
        "海带宝",
        "汇丰美中速递",
        "豪杰速递",
        "华美快递",
        "360hitao转运",
        "海淘村",
        "365海淘客",
        "华通快运",
        "海星桥快递",
        "华兴速运",
        "LogisticsY",
        "领跑者快递",
        "量子物流",
        "明邦转运",
        "168美中快递",
        "欧e捷",
        "欧洲疯",
        "欧洲GO",
        "全美通",
        "直德邮",
        "三三国际物流",
        "招金精炼",
        "鑫正一快递",
        "中宏物流",
        "中环转运",
        "中速快件",
        "中铁飞豹",
        "忠信达",
        "众派速递",
        "创运物流",
        "振捷国际货运",
        "苏通快运",
        "三真驿道",
        "中粮鲜到家物流",
        "中通智运",
        "中融泰隆",
        "准实快运",
        "明辉物流",
        "中途速递",
        "纵通速运",
        "中网物流",
        "爱购转运",
        "澳世速递",
        "斑马物流",
        "百通物流",
        "策马速递",
        "宜送转运",
        "飞碟快递",
        "飞鸽快递",
        "风行快递",
        "皓晨快递",
        "君安快递",
        "骏达快递",
        "久禾快运",
        "金海淘",
        "龙象快递",
        "美速通",
        "QQ-EX",
        "瑞天快递",
        "四方转运",
        "上腾快递",
        "滕牛快递",
        "唐三藏转运",
        "同心快递",
        "天翼快递",
        "星辰快递",
        "先锋快递",
        "云骑快递",
        "运淘美国",
        "中远快运",
        "增速海淘",
        "郑州建华",
        "SCS国际物流",
        "SOHO苏豪国际",
        "Sonic-Ex速递",
        "通诚美中快递",
        "TrakPak",
        "天天海淘",
        "天泽快递",
        "迅达快递",
        "信达速运",
        "新干线快递",
        "信捷转运",
        "优购快递",
        "友家速递(UCS)",
        "云畔网",
        "易送网",
        "中运全速",
        "中邮物流",
        "汇强快递",
        "众通快递",
        "中通快运",
        "中通冷链",
        "中骅物流",
        "中铁物流",
        "智汇鸟",
        "中原快运",
        "正鑫小飞侠",
      ],
      trackingNoSel: "",
      customerName: "",
      queryResult: "",
      queryErrorMessage: "",
      list: [],
    };
  },
  methods: {
    commit() {
      this.commitResult = "";
      this.errorCommitResult = "";
      const url =
        this.$root.ycApiUrl + "api/express/two-stage-logistics-update?trackingNo=" +
        this.trackingNo +
        "&shipperCode=" +
        this.shipperCode +
        "&expressNo=" +
        this.expressNo;
      const res = axios.post(url);
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            this.commitResult = resd.message;
          } else {
            this.errorCommitResult = resd.message;
          }
          setTimeout(() => {
            return;
          }, 1.5 * 1000);
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          // 处理错误，比如设置data为默认值或错误状态
          return;
        });
      // Just to simulate the time of the request
      setTimeout(() => {
        this.listLoading = false;
      }, 1.5 * 1000);
    },
    queryByTrackingNo() {
      this.commitResult = "";
      this.errorCommitResult = "";
      const url = this.$root.ycApiUrl + "api/express/select-order-info";
      const res = axios.get(url, {
        params: { trackingNo: this.trackingNoSel },
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            this.queryResult = resd.data[this.trackingNoSel];
          }
          setTimeout(() => {
            return;
          }, 1.5 * 1000);
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          // 处理错误，比如设置data为默认值或错误状态
          return;
        });
      // Just to simulate the time of the request
      setTimeout(() => {
        this.listLoading = false;
      }, 1.5 * 1000);
    },
    selectOrderTrack() {
      this.commitResult = "";
      this.errorCommitResult = "";
      this.list = [];
      const url =
        this.$root.ycApiUrl + "api/express/select-order-track?trackingNo=" +
        this.trackingNoSel +
        "&customerName=" +
        this.customerName;
      const res = axios.post(url);
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            this.list = resd.data[this.trackingNoSel];
            this.queryResult = resd.data;
          } else {
            this.queryErrorMessage = resd.message;
          }
          setTimeout(() => {
            return;
          }, 1.5 * 1000);
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          // 处理错误，比如设置data为默认值或错误状态
          return;
        });
      // Just to simulate the time of the request
      setTimeout(() => {
        this.listLoading = false;
      }, 1.5 * 1000);
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/secondGenerationLogistics/index.vue